import React, { useState, useEffect } from "react";
import { Col, Row, Button, Form, Alert, Spinner } from "react-bootstrap";
import { driverPay_source, RoutingServiceResponse } from '../DCR.dtos';
import routingLogo from '../skin/images/u110_normal.gif';
import { CheckWrapper } from "./CheckWrapper";
import { PhoneNumberControl } from "./PhoneNumberControl";
import { checkABA } from "../functions/checkABA";
import { accountActionCreators, AccountAction } from '../store/AccountStore';
import { AppState } from '../store/configureStore';
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { helperActionCreators } from '../store/HelperStore';
import { connect } from 'react-redux';
import Skeleton from "react-loading-skeleton";
import { getUnformattedString, encodeForOmni } from "../functions/dcrGlobal";
import { Permissions } from '../store/HelperStore';
import { hasPermission } from '../functions/hasPermission';
import { maskAccountNumber } from "../functions/dcrGlobal";


export interface AddUpdateAccountProps {
    showAddUpdate: boolean;
    actionMode: AccountAction;
    onClose: any;
    bankDetails: driverPay_source | null;
    onVerifyCancel: any;
}

export type TAddUpdateAccount = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const AddUpdateAccountComp = function (props: TAddUpdateAccount) {
    const isProcessing = (props.accounts.isAccountUpdating && !props.accounts.isAccountUpdated);

    const getFieldValueByName = (fieldName: string) => {
        if (props.addUpdateProps.actionMode === AccountAction.EDIT && fieldName?.trim()?.length > 0) {
            if (fieldName.includes("~")) {
                return decodeURIComponent(props.addUpdateProps?.bankDetails?.source_info.find(x => (x.name === fieldName.split("~")[0] || x.name === fieldName.split("~")[1]))?.value ?? "");
            }
            else {
                return decodeURIComponent(props.addUpdateProps?.bankDetails?.source_info.find(x => (x.name === fieldName))?.value ?? "");
            }
        }
        return "";
    }

    const [bankName, setBankName] = useState(getFieldValueByName("Bank Name:~Wespath Account Name:"));
    const [accountName, setAccountName] = useState(getFieldValueByName("Account Name:"));
    const [accountType, setAccountType] = useState(getFieldValueByName("Account Type:"));
    const [routingNumber, setRoutingNumber] = useState(getFieldValueByName("Transit Routing Number:"));
    const [accountNumber, setAccountNumber] = useState(getFieldValueByName("Account Number:~Wespath Account Number:"));
    const [hasAccountNumberChanged, setHasAccountNumberChanged] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(getFieldValueByName("Phone Number:"));
    const lastUpdatedBy = getFieldValueByName("Last Updated by:");
    const [showRoutingError, setShowRoutingError] = useState(false);
    const [showPhoneError, setShowPhoneError] = useState(false);
    const [errorCSSRoutingNumber, setErrorCSSRoutingNumber] = useState("");
    const [errorCSSPhoneNumber, setErrorCSSPhoneNumber] = useState("");
    const [enableContinue, setEnableContinue] = useState(false);
    const [hasClickedContinue, setHasClickedContinue] = useState(false);
    const [accountInfoTabActive, setAccountInfoTabActive] = useState(true);
    const [confirm, setConfirm] = useState(false);
    const [showVarificationMessage, setShowVarificationMessage] = useState(false);
    const [isCompDataUpdated, setIsCompDataUpdated] = useState(false);
    const [isErrorOnAccountUpdate, setIsErrorOnAccountUpdate] = useState(false);
    
    const updatePaymentSubmitClaim = hasPermission(Permissions.UpdatePayment_Submit, props.currentUser.permissions);


    enum AccountInputControl {
        BANKNAME,
        ACCOUNTNAME,
        ACCOUNTNUMBER,
        PHONENUMBER,
        ROUTINGNUMBER
    }

    
    const validateRoutingNumber = () => {
        //console.log("inside routing validation ", routingNumber);
       
        if (routingNumber?.length === 9) {
            setShowRoutingError(!(checkABA(routingNumber)));
        }
        else {
            setShowRoutingError(false);
        }
    }
    const clickContinue = () => {
        setHasClickedContinue(true);
        props.checkRoutingRumber(routingNumber, accountNumber, getInstitutionName());
    }

    const validatePhoneControlData = () => {
        if (!(getUnformattedString(phoneNumber)?.length === 0 || getUnformattedString(phoneNumber)?.length === 10)) {
            setShowPhoneError(true);
        }
        else {
            setShowPhoneError(false);
        }
    }

    useEffect(() => {
        validatePhoneControlData();
    }, [phoneNumber])

    useEffect(() => {
        if (isCompDataUpdated) {
            validateRoutingNumber();
        }
    }, [routingNumber])


    const setEnableDisableContinue = () => {
        const isFormValid: boolean = (!showPhoneError && !showRoutingError &&
            bankName?.trim()?.length > 0 && accountName?.trim()?.length > 0 &&
            accountNumber?.trim().length > 0 && accountType?.trim().length > 0 &&
            routingNumber?.trim().length === 9);

        setEnableContinue(isFormValid);
    }

    const getInstitutionName = (): string => {
        if (props.currentUser) {
            return props.currentUser?.institutions.find(x => x.value === props.dcr?.selectedInstitution)?.display ?? "";
        }
        return "";
    }

    useEffect(() => {
        setEnableDisableContinue();
    }, [bankName, accountName, accountNumber, accountType, routingNumber, showPhoneError, showRoutingError])

    useEffect(() => {
        if (confirm) {
            setShowVarificationMessage(false);
        }
    }, [confirm])

    useEffect(() => {
        if (props.accounts.isroutingServiceLoaded) {
            const routingResponse: RoutingServiceResponse = props.accounts.routingResponse;          
            if (routingResponse.success === "n") {
                setShowRoutingError(true);
            }
            else {
                setShowRoutingError(false);
                if (hasClickedContinue) {
                    setAccountInfoTabActive(false);
                }
            }
            setHasClickedContinue(false);
        }
    }, [props.accounts.isroutingServiceLoaded])

    useEffect(() => {
        if (props.accounts.isAccountUpdated) {
            if (!props.accounts.isUpdateAccountError) {
                props.addUpdateProps.onVerifyCancel(true);
            }
            else {
                setIsErrorOnAccountUpdate(true);
            }
        }
    }, [props.accounts.isAccountUpdated])

    const generateXML = () => {
        let xmlData = "";
        const strLastUpdated = props.currentUser.userName;
        const strRootNodeWithAttribute = '<pay_source org_id="#valueRootAttribute1#" action="#valueRootAttribute2#" sequence="#valueRootAttribute3#">';
        const strChildNodeWithAttribute = '<source_info id="#id#" name="#parameterName#" value="#value#" />';

        xmlData = strRootNodeWithAttribute.replace("#valueRootAttribute1#", props.dcr.selectedInstitution)
            .replace("#valueRootAttribute2#", AccountAction[props.addUpdateProps.actionMode].toString().toLowerCase()).replace("#valueRootAttribute3#", props?.addUpdateProps?.actionMode === AccountAction.ADD ? "" : props?.addUpdateProps?.bankDetails?.sequence?.toString().padStart(3, "0") ?? "");

        //On the Update Account Info, we need to allow special characters,  i.e “Teddy’s Bank”, “AT&T”, etc…
        //var bankName = encodeForOmni(self.parent.wizardBankName());
        //var accountName = encodeForOmni(self.parent.wizardAccountName());

        const bankNameNode = strChildNodeWithAttribute.replace("#id#", "1").replace("#parameterName#", "Bank Name:").replace("#value#", encodeForOmni(bankName?.trim()));
        const phoneNumberNode = strChildNodeWithAttribute.replace("#id#", "2").replace("#parameterName#", "Phone Number:").replace("#value#", phoneNumber);
        const accountNameNode = strChildNodeWithAttribute.replace("#id#", "3").replace("#parameterName#", "Account Name:").replace("#value#", encodeForOmni(accountName?.trim()));
        const accountNumberNode = strChildNodeWithAttribute.replace("#id#", "4").replace("#parameterName#", "Account Number:").replace("#value#", accountNumber);
        const accountTypeNode = strChildNodeWithAttribute.replace("#id#", "5").replace("#parameterName#", "Account Type:").replace("#value#", accountType);
        const transitRoutingNumberNode = strChildNodeWithAttribute.replace("#id#", "6").replace("#parameterName#", "Transit Routing Number:").replace("#value#", routingNumber?.trim());
        const lastUpdatedNode = strChildNodeWithAttribute.replace("#id#", "7").replace("#parameterName#", "updatedby:").replace("#value#", strLastUpdated);

        xmlData = xmlData.concat(bankNameNode)
            .concat(phoneNumberNode)
            .concat(accountNameNode)
            .concat(accountNumberNode)
            .concat(accountTypeNode)
            .concat(transitRoutingNumberNode)
            .concat(lastUpdatedNode);

        xmlData = xmlData.concat("</pay_source>");
        return xmlData;
    }


    const submitClick = () => {
        if (!confirm) {
            setShowVarificationMessage(true);
        }
        else {
            const strXML = generateXML();
            props.updateBankAccountInfo(strXML);
        }
    }

    const validateName = (e: any, ctrlType: AccountInputControl) => {
        //PA - Please do not allow '~' sign as a valid input character becaues it is used in a special logic, which can break if we allow it here.
        const re = new RegExp(/^[ A-Za-z0-9&-.,/()]*$/);
        if (!e.target.value || re.test(e.target.value)) {
            if (ctrlType === AccountInputControl.BANKNAME) {
                setBankName(e.target.value);
            }

            if (ctrlType === AccountInputControl.ACCOUNTNAME) {
                setAccountName(e.target.value);
            }
            setIsCompDataUpdated(true);
        }
        else {
            e.target.value = e.target.value.substr(0, e.target.value.length - 1);
        }
    }
    
    const validateNumber = (e: any, ctrlType: AccountInputControl) => {
        const re = new RegExp(/^\d+$/);

        //phone number is a component which validates the number and teturns the formated text so skipping the numeric check.
        if (ctrlType === AccountInputControl.PHONENUMBER) {
            setPhoneNumber(e.formattedValue);
            setIsCompDataUpdated(true);
            return;
        }
        else if (ctrlType === AccountInputControl.ACCOUNTNUMBER ) {
            let newVal = e.target.value

            if (!hasAccountNumberChanged) 
                newVal = newVal?.length > accountNumber.length ? newVal.substr(newVal.length - 1, 1) : ""

            if (newVal === "" || re.test(newVal)) {
                setAccountNumber(newVal);
                setHasAccountNumberChanged(true);
                setIsCompDataUpdated(true);
            }
        }

        else if (!e.target.value || re.test(e.target.value)) {
            if (ctrlType === AccountInputControl.ROUTINGNUMBER) {
                setRoutingNumber(e.target.value);
            }
            setIsCompDataUpdated(true);
        }
        else {
            e.target.value = e.target.value.substr(0, e.target.value.length - 1);
        }
    }

    const handleAccountTypeChage = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAccountType(e.target.value);
        setIsCompDataUpdated(true);
    }

   

    const getLastUpdatedBy = () => {
        if (lastUpdatedBy !== "" && lastUpdatedBy !== "UNDEFINED") {
            return "Last updated by " + lastUpdatedBy;
        }
        else if (props.addUpdateProps.actionMode === AccountAction.ADD) {
            const today = new Date();
            const date = (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear();
            return "Last updated by " + props.currentUser.userName + " on " + date;
        }
        else {
            let lastUpdatedOn = "";
            if (lastUpdatedBy !== null && lastUpdatedBy.includes(" on ")) {
                lastUpdatedOn = lastUpdatedBy.split(" on ")[1];
            }
            return "Last updated on " + lastUpdatedOn;
        }
    }

    return (
        <>
            <Row className="tbl-info-wrap">
                <Col className="float-left">
                    <h4>Update Payment Information</h4>
                </Col>
            </Row>
            {isErrorOnAccountUpdate &&
                <Row>
                    <Alert className="mt-2" variant="danger">Problem while updating Payment Informaiton. Reason: {props.accounts.updateAccountErrorMessage}</Alert>
                </Row>
            }
            <div className="crumbs">
                <div className={accountInfoTabActive ? "active" : ""}>
                    {accountInfoTabActive ? <> Enter Organization Account Information </> :
                        <> <a style={{ cursor: "pointer" }} className="mx-0 my-0 px-0 py-0" onClick={() => { setAccountInfoTabActive(true) }}>Enter Account Information</a> </>}
                </div>
                <div className={!accountInfoTabActive ? "active" : ""}>
                    Verify
                </div>
            </div>
            {accountInfoTabActive ?
                <>
                    <Row>
                        <Col>
                            <Row>
                                <Col className="col-12 col-sm-6">
                                    <div className="form-group">
                                        <label className="control-label">Bank Name:</label>
                                        <span className="asterisk">&nbsp;*</span>
                                        <Form.Control type="text" name="_bank_name" id="_bank_name"
                                            value={bankName} maxLength={40} onChange={(e) => { validateName(e, AccountInputControl.BANKNAME) }} />
                                    </div>
                                </Col>
                                <Col className="col-12 col-sm-6">
                                    <div className="form-group">
                                        <label className="control-label">Phone Number:</label>
                                        <PhoneNumberControl className={`${errorCSSPhoneNumber}`} name="_phone" id="_phone"
                                            defaultValue={phoneNumber} onChange={(e: any) => { validateNumber(e, AccountInputControl.PHONENUMBER) }}
                                            onBlur={(e: any) => { setErrorCSSPhoneNumber(showPhoneError ? "is-error" : ""); }}
                                        />
                                        <div className="error-feedback">
                                            The bank phone you entered is invalid. Please enter a valid phone number.
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col className="col-sm-6">
                                    <div className="form-group">
                                        <label className="control-label">Account Name:</label>
                                        <span className="asterisk">&nbsp;*</span>
                                        <Form.Control type="text" name="_account_name" id="_account_name"
                                            value={accountName} maxLength={40} onChange={(e) => { validateName(e, AccountInputControl.ACCOUNTNAME) }} />
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col className="col-sm-6">
                                    <div className="form-group">
                                        <label className="control-label">Account Type:</label>
                                        <span className="asterisk">&nbsp;*</span>
                                        <Row>
                                            <Col className="col-md-5 col-sm-5">
                                                <CheckWrapper>
                                                    <Form.Check type="radio" name="_rdo_account_type" id="_rdoChecking" value="Checking" onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleAccountTypeChage(e) }}
                                                        custom checked={accountType?.toLowerCase() === "checking"} label="Checking" />
                                                </CheckWrapper>
                                            </Col>
                                            <Col className="col-md-5 col-sm-5">

                                                <CheckWrapper>
                                                    <Form.Check type="radio" name="_rdo_account_type" id="_rdoSaving" value="Savings" onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleAccountTypeChage(e) }}
                                                        custom checked={accountType?.toLowerCase() === "savings"} label="Saving" />
                                                </CheckWrapper>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Transit Routing Number:</label>
                                        <span className="asterisk">&nbsp;*</span>
                                        <Form.Control type="text" name="_routing_num" id="_routing_num" className={`${errorCSSRoutingNumber} ${showRoutingError ? "is-error" : "" }`}
                                            maxLength={9} value={routingNumber} onChange={(e) => { validateNumber(e, AccountInputControl.ROUTINGNUMBER) }}
                                        />
                                        <div className="error-feedback">
                                            The bank information you entered is invalid. Please enter a valid bank transit routing number.
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label">Account Number:</label>
                                        <span className="asterisk">&nbsp;*</span>
                                        <Form.Control type="text" name="_account_num" id="_account_num" className={""} onPaste={(e: { preventDefault: () => void }) => { e.preventDefault(); return false; }}
                                            maxLength={20} value={hasAccountNumberChanged ? accountNumber : maskAccountNumber(accountNumber)} onChange={(e) => { validateNumber(e, AccountInputControl.ACCOUNTNUMBER) }} />
                                    </div>
                                </Col>
                                <Col className="col-12 col-md-6 mb-3 mb-md-0">
                                    <div className="form-group extra-top-padding">
                                        <img alt="routingLogo" src={routingLogo} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="mt-2 text-required">*These fields are required and should reflect the organization’s bank account.</div>
                                </Col>
                            </Row>
                            <Row className="">
                                <Col>
                                    <div className="border-top mt-1 pt-1 mb-5">

                                        <Button variant="primary" className="btn-block-xs-only float-right btn btn-primary"
                                            onClick={() => { clickContinue() }}
                                            disabled={!enableContinue || hasClickedContinue}
                                        >
                                            {hasClickedContinue ? <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            /> : "Continue"}
                                        </Button>
                                        <Button variant="secondary"
                                            className="btn-block-xs-only float-right mr-sm-3 btn btn-secondary"
                                            onClick={() => { props.addUpdateProps.onClose(); }}
                                            disabled={hasClickedContinue}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>
                :
                <>
                    <Row className="pb-3">
                        <Col className="col-xs-12">Please review the following information. If it is accurate, check the box below and select continue.</Col>
                    </Row>
                    <Row>
                        <Col className="col-12 col-sm-4 pb-2">
                            <label className="control-label">Bank Name:</label>
                            <div>{bankName}</div>
                        </Col>
                        <Col className="col-12 col-sm-4 pb-2">
                            <label className="control-label">Phone Number:</label>
                            <div>{phoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 col-sm-4 pb-2">
                            <label className="control-label">Account Name:</label>
                            <div>{accountName}</div>
                        </Col>
                        <Col className="col-12 col-sm-4 pb-2">
                            <label className="control-label">Account Type:</label>
                            <div>{accountType}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 col-sm-4 pb-2">
                            <label className="control-label">Transit Routing Number:</label>
                            <div>{routingNumber}</div>
                        </Col>
                        <Col className="col-12 col-sm-4 pb-2">
                            <label className="control-label">Account Number:</label>
                            <div>{hasAccountNumberChanged ? accountNumber : maskAccountNumber(accountNumber)}</div>
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <CheckWrapper>
                            <Form.Check className={"ml-4"} custom onChange={() => setConfirm(!confirm)} defaultChecked={confirm} id="chk_agree" type="checkbox" value="Y" label="I verify that the above information is correct and will be used to fund contributions." />
                        </CheckWrapper>
                    </Row>
                    {showVarificationMessage &&
                        <div>
                            <Alert className="ml-2" variant="danger">You must verify the information by checking the box above before continuing.</Alert>
                        </div>
                    }
                    <Row>
                        <Col className="col-sm-12">
                            <div className="text-left small em"><i>{getLastUpdatedBy()}</i></div>
                        </Col>
                    </Row>

                    <div className="border-top my-3 pt-2">
                        <Button 
                            className="btn-block-xs-only float-right btn btn-primary"
                            onClick={() => { submitClick() }}
                            disabled={!updatePaymentSubmitClaim || isProcessing}
                        >
                            {isProcessing ? <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> : "Continue"}
                        </Button>
                        <Button variant="secondary"
                            className="btn-block-xs-only float-right mr-sm-3 btn btn-secondary"
                            onClick={() => { props.addUpdateProps.onVerifyCancel(false) }}
                            disabled={isProcessing}
                        >
                            Cancel
                        </Button>
                        <a className="btn-block-xs-only float-left no-after btn btn-link" onClick={() => { setAccountInfoTabActive(true) }}>&lt; Back</a>
                    </div>
                </>
            }
        </>
    );

}

function mapStateToProps(state: AppState, addUpdateProps: AddUpdateAccountProps) {
    return {
        dcr: state.dcr,
        currentUser: state.dcr.currentuserInfo?.user,
        accounts: state.accounts,
        addUpdateProps: addUpdateProps
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({ ...accountActionCreators, ...helperActionCreators }, dispatch);
}

export const AddUpdateAccount = connect(
    mapStateToProps,
    mapDispatchToProps
)(AddUpdateAccountComp);
